<template>
  <div class="cp-box" v-if="partner">
    <ul class="sub-tabs">
      <li :class="{ active: activeTab === 'users' }" @click="activeTab = 'users'"><a>Users</a></li>
      <li :class="{ active: activeTab === 'log' }" @click="activeTab = 'log'"><a>User Log</a></li>
    </ul>
    <hr>
    <access-users v-if="activeTab === 'users'" :partner="partner" />
    <access-user-log v-if="activeTab === 'log'" :partner="partner" />
  </div>
</template>

<script>
import AccessUsers from './AccessUsers'
import AccessUserLog from './AccessUserLog'

export default {
  components: {
    AccessUsers,
    AccessUserLog
  },

  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },

  data () {
    return {
      activeTab: 'users'
    }
  },

  computed: {
    partner () {
      return this.$store.getters['partners/get'](this.id)
    }
  }
}
</script>
